import React from 'react';
import './AboutPageQuote.scss';

const AboutPageQuote = () => {
  return (
    <section className="about-quote">
      <div className="quote-container">
        <div className="quote-card">
          <div className="quote-content">
            <blockquote className="quote-text">
              "We didn't want to build another freelancing platform.
              <br />
              We wanted to build <span className="highlight-text">THE</span>  Freelancing platform that would finally give Indian freelancers the respect and opportunities they deserve."
            </blockquote>
            <div className="quote-attribution">
              — The Founders
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPageQuote;

